import { POSITIONS } from '../../../types/positions/positions';
export const getValueOfRadioButton = (position, inputValues) => {
    if (position === POSITIONS.RIGHT) {
        return inputValues?.rightInputValue;
    }
    else if (position === POSITIONS.LEFT) {
        return inputValues?.leftInputValue;
    }
    return inputValues?.centerInputValue;
};
//# sourceMappingURL=getValueOfRadioButton.js.map